import { render, staticRenderFns } from "./InventoryChangesContent.vue?vue&type=template&id=3f230b7d&scoped=true&"
import script from "./InventoryChangesContent.vue?vue&type=script&lang=js&"
export * from "./InventoryChangesContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f230b7d",
  null
  
)

export default component.exports